import React, { PureComponent } from "react";
import TeamReportsTopNavigation from "../components/team-reports/navigation/top";
import TeamReportsSection1 from "../components/team-reports/sections/section-1";
import TeamReportsSection2 from "../components/team-reports/sections/section-2";
import TeamReportsSection3 from "../components/team-reports/sections/section-3";
import TeamReportsSection4 from "../components/team-reports/sections/section-4";
import TeamReportsSection5 from "../components/team-reports/sections/section-5";
import TeamReportsSection6 from "../components/team-reports/sections/section-6";
import TeamReportsSection7 from "../components/team-reports/sections/section-7";
import Teams from "../api/Teams";
import { getRequest } from "../api/ApiService";
import EventEmitter from "../services/event-emitter";
import { Loader } from "react-loaders";

class TeamReports extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loading1: true,
      loading2: true,
      loading3: true,
      loading4: true,
      loading5: true,
      loading6: true,
      loading7: true,
      loading8: true,
      loading9: true,
      loading10: true,
      loading11: true,
      section: 1,
      step: 1,
      data: {},
      teams: {},
      expected: {},
      actual: {},
      competition_metrics: {},
      netRevenues: 0,
      netProfits: 0,
      costOfSales: 0,
      rndCosts: 0,
      promotionCosts: 0,
      sellingCosts: 0,
      holdingCosts: 0,
      avgMaterialCostsPerUnit: 0,
      avgLaborCostsPerUnit: 0,
      avgOverheadCostsPerUnit: 0,
      interestExpense: 0,
      financeRaised: 0,
      returnedToInvestors: 0,
      currentRound: props.currentRound,
      roundInUrl: props.roundInUrl,
      rounds: props.rounds,
      endingInventory: 0,
      totalCosts: 0,
      metrics: {
        debt: "0.00",
        equity: "100.00",
        wacc: "0.00"
      },
      incomeStatement: {
        costOfSales: {
          name: "Cost of Sales",
          data: {}
        },
        revenues: {
          name: "Net Revenues",
          data: {}
        },
        grossProfits: {
          name: "Gross Profit",
          data: {}
        },
        RnDCosts: {
          name: "R&D Costs",
          data: {}
        },
        holdingCosts: {
          name: "Holding Costs",
          data: {}
        },
        promotionCosts: {
          name: "Promotion Costs",
          data: {}
        },
        sellingCosts: {
          name: "Selling Costs",
          data: {}
        },
        gnACosts: {
          name: "Other G&A Costs",
          data: {}
        },
        incomingBeforeTaxes: {
          name: "Income Before Taxes",
          data: {}
        },
        taxes: {
          name: "Taxes",
          data: {}
        },
        totalOperatingExpenses: {
          name: "Total Operating Costs",
          data: {}
        },
        totalNonOperatingCost: {
          name: "Total Non-Operating Costs",
          data: {}
        },
        gainOrLossoFSales: {
          name: "Gain or Loss of Sales",
          data: {}
        },
        interestExpense: {
          name: "Interest Expense",
          data: {}
        },
        otherNonOperatingCosts: {
          name: "Other Non-Operating Costs",
          data: {}
        },
        netIncome: {
          name: "Net Income",
          data: {}
        }
      },
      balanceSheet: {
        accountsPayable: {
          name: "Accounts Payable",
          data: {}
        },
        accountsReceivable: {
          name: "Accounts Receivable",
          data: {}
        },
        accruedExpenses: {
          name: "Accrued Expenses",
          data: {}
        },
        accumulatedDepreciation: {
          name: "Accumulated Depreciation",
          data: {}
        },
        additionalPaidinCapital: {
          name: "Additional Paid in Capital",
          data: {}
        },
        begRetainedEarnings: {
          name: "Beg Retained Earnings",
          data: {}
        },
        cash: {
          name: "Cash",
          data: {}
        },
        commonStock: {
          name: "Common Stock",
          data: {}
        },
        currentLiabilities: {
          name: "Current Liabilities:",
          data: {}
        },
        deferredRevenues: {
          name: "Deferred Revenues",
          data: {}
        },
        dividends: {
          name: "Dividends",
          data: {}
        },
        inventory: {
          name: "Inventory",
          data: {}
        },
        longTermDebt: {
          name: "Long Term Debt",
          data: {}
        },
        longTermLiabilities: {
          name: "Long Term Liabilities:",
          data: {}
        },
        netIncome: {
          name: "Net Income",
          data: {}
        },
        otherCurrentLiabilities: {
          name: "Other Current Liabilities",
          data: {}
        },
        otherLongTermLiabilities: {
          name: "Other Long Term Liabilities",
          data: {}
        },
        ppe: {
          name: "PPE",
          data: {}
        },
        preferredStock: {
          name: "Preferred Stock",
          data: {}
        },
        prepaidExpenses: {
          name: "Prepaid Expenses",
          data: {}
        },
        shortTermDebt: {
          name: "Short Term Debt",
          data: {}
        },
        supplies: {
          name: "Supplies",
          data: {}
        },
        totalAssets: {
          name: "Total Assets",
          data: {}
        },
        totalCurrentAssets: {
          name: "Total Current Assets",
          data: {}
        },
        totalCurrentLiabilities: {
          name: "Total Current Liabilities",
          data: {}
        },
        totalEquity: {
          name: "Total Equity",
          data: {}
        },
        totalLiabilities: {
          name: "Total Liabilities",
          data: {}
        },
        totalLongTermAssets: {
          name: "Total Long Term Assets",
          data: {}
        },
        totalLongTermLiabilities: {
          name: "Total Long Term Liabilities",
          data: {}
        }
      },
      cashFlow: {
        beginningCash: {
          name: "Beginning Cash",
          data: {}
        },
        capitalExpenditurePurchases: {
          name: "Capital Expenditure Purchases",
          data: {}
        },
        capitalExpenditureSales: {
          name: "Capital Expenditure Sales",
          data: {}
        },
        cashpaymentforIncomeTaxes: {
          name: "Cash payment for Income Taxes",
          data: {}
        },
        cashpaymentforInterests: {
          name: "Cash payment for Interests",
          data: {}
        },
        cashpaymentsforOperatingexpenses: {
          name: "Cash payments for Operating expenses",
          data: {}
        },
        cashpaymentsforPurchases: {
          name: "Cash payments for Purchases",
          data: {}
        },
        cashpaymentsforWages: {
          name: "Cash payment for Wages",
          data: {}
        },
        cashreceivedfromCustomers: {
          name: "Cash received from Customers",
          data: {}
        },
        debtBorrowed: {
          name: "Debt Borrowed",
          data: {}
        },
        debtRepaid: {
          name: "Debt Repaid",
          data: {}
        },
        dividends: {
          name: "Dividends",
          data: {}
        },
        endingCash: {
          name: "Ending Cash",
          data: {}
        },
        investmentPurchases: {
          name: "Investment Purchases",
          data: {}
        },
        investmentSales: {
          name: "Investment Sales",
          data: {}
        },
        netChangeinCash: {
          name: "Net Change in Cash",
          data: {}
        },
        stockIssuance: {
          name: "Stock Issuance",
          data: {}
        },
        stockRepurchase: {
          name: "Stock Repurchase",
          data: {}
        },
        totalCashFlowsfromFinancing: {
          name: "Total Cash Flows from Financing",
          data: {}
        },
        totalCashFlowsfromInvesting: {
          name: "Total Cash Flows from Investing",
          data: {}
        },
        totalCashFlowsfromOperations: {
          name: "Total Cash Flows from Operations",
          data: {}
        }
      },
      total_demand: {
        auto: 0,
        mobile: 0,
        total: 0
      },
      share_price: 0
    };

    this.eventemitter = EventEmitter.getInstance();
  }

  componentDidMount() {
    this.fetchData();
    this.eventemitter.on("team-reports-go-to-section", this.goToSection);
  }

  componentWillUnmount() {
    this.eventemitter.off("team-reports-go-to-section", this.goToSection);
  }

  getCompetitiveAnalysis() {
    const { currentRound, roundInUrl, rounds } = this.state;

    const base_url = `${process.env.REACT_APP_API_URL}competition/competitive_analysis/`;
    let url = "";
    if (roundInUrl !== null && roundInUrl !== currentRound) {
      let round = rounds.find(i => i.number === roundInUrl);
      if (round) {
        url = `${base_url}?round=${round.id}`;
      }
    } else {
      let round = rounds.find(i => i.number === currentRound);
      if (round) {
        if (round.is_finished === true) {
          url = `${base_url}?round=${round.id}`;
        } else {
          const round_number = currentRound - 1;
          if (round_number > 0) {
            round = rounds.find(i => i.number === round_number);
            if (round) {
              url = `${base_url}?round=${round.id}`;
            }
          }
        }
      }
    }

    if (url === "") {
      return null;
    }

    return url;
  }

  getCompetitionMetrics() {
    const { currentRound, roundInUrl } = this.state;
    let round_number = currentRound;
    const base_url = `${process.env.REACT_APP_API_URL}competition/metrics/`;

    if (roundInUrl !== null && roundInUrl !== currentRound) {
      round_number = roundInUrl;

      return `${base_url}?round_number=${round_number}`;
    }

    return `${base_url}?round_number=${round_number}`;
  }

  componentWillReceiveProps(nextProps) {
    let needUpdate = false;
    if (this.state.roundInUrl !== nextProps.roundInUrl) {
      needUpdate = true;
    }

    if (this.state.currentRound !== nextProps.currentRound) {
      needUpdate = true;
    }

    if (this.state.rounds.length === 0 && nextProps.rounds.length !== 0) {
      needUpdate = true;
    }

    const round1 = this.state.rounds.find(
      i => i.number === nextProps.currentRound
    );
    const round2 = nextProps.rounds.find(
      i => i.number === nextProps.currentRound
    );
    if (round1 && round2 && round1.is_finished !== round2.is_finished) {
      needUpdate = true;
    }

    if (needUpdate === true) {
      this.setState(
        {
          roundInUrl: nextProps.roundInUrl,
          currentRound: nextProps.currentRound,
          rounds: nextProps.rounds
        },
        () => {
          this.fetchData();
        }
      );
    }
  }

  fetchData = () => {
    let teams = {};
    let data = {};

    this.setState({
      loading1: true,
      loading2: true,
      loading3: true,
      loading4: true,
      loading5: true,
      loading6: true,
      loading7: true,
      loading8: true,
      loading9: true,
      loading10: true,
      loading11: true
    });

    this.loadFinanceData();
    this.loadIncomeStatementData();
    this.loadBalanceSheetData();
    this.loadTotalDemand();
    this.loadManufactureCosts();
    this.loadInventoryBalances();
    this.loadMetricsData();
    this.loadCashFlow();
    this.loadSharePrice();
    this.loadCompetitionMetrics();

    Teams.teams().forEach(item => {
      teams[item.id] = item.name;
      data[item.id] = {};
    });

    this.setState(
      {
        teams,
        data
      },
      () => {
        this.loadState();
      }
    );
  };

  getFinancialAnalysis() {
    const base_url = `${process.env.REACT_APP_API_URL}team/financial_analysis/`;
    const { currentRound, roundInUrl } = this.state;

    let url = `${base_url}?round_lte=${currentRound}`;
    if (roundInUrl !== null && roundInUrl !== currentRound) {
      url = `${base_url}?round_lte=${roundInUrl}`;
    }

    return getRequest(url);
  }

  loadFinanceData = () => {
    this.getFinancialAnalysis()
      .then(res => {
        let actual = {};
        let expected = {};

        res.body.forEach(item => {
          if (item.is_actual === true) {
            actual[item.target_round_number] = item;
          } else {
            expected[item.target_round_number] = item;
          }
        });

        this.setState({
          actual,
          expected,
          loading1: false
        });
      })
      .catch(err => { });
  };

  loadState = () => {
    if (this.joinRequest) {
      this.joinRequest.abort();
      this.joinRequest = null;
    }

    const request = this.getCompetitiveAnalysis();
    if (request) {
      this.joinRequest = getRequest(request);
      this.joinRequest
        .then(res => {
          let data = { ...this.state.data };
          const exclude_keys = [
            "created_at",
            "id",
            "is_actual",
            "reason",
            "round",
            "team",
            "updated_at"
          ];

          res.body.forEach(item => {
            if (item.team in data) {
              Object.keys(item).forEach(key => {
                if (exclude_keys.includes(key)) {
                  return;
                }

                data[item.team][key] = item[key] === null ? 0 : item[key];
              });
            }
          });

          this.setState(
            {
              data,
              loading2: false
            },
            () => {
              this.joinRequest = null;
            }
          );
        })
        .catch(err => { });
    }
  };

  getIncomeStatement() {
    const base_url = `${process.env.REACT_APP_API_URL}team/report/income_statement/`;
    let url = `${base_url}?round_lte=${this.props.currentRound}`;
    if (
      this.state.roundInUrl !== null &&
      this.state.roundInUrl !== this.props.currentRound
    ) {
      url = `${base_url}?round_lte=${this.state.roundInUrl}`;
    }

    return getRequest(url);
  }

  getBalanceSheet() {
    const base_url = `${process.env.REACT_APP_API_URL}team/report/balance_sheet/`;
    let url = `${base_url}?round_lte=${this.props.currentRound}`;
    if (
      this.state.roundInUrl !== null &&
      this.state.roundInUrl !== this.props.currentRound
    ) {
      url = `${base_url}?round_lte=${this.state.roundInUrl}`;
    }

    return getRequest(url);
  }

  loadIncomeStatementData = () => {
    let incomeStatement = { ...this.state.incomeStatement };

    for (let key in incomeStatement) {
      incomeStatement[key].data = {
        value: 0
      };
    }

    this.getIncomeStatement()
      .then(res => {
        const { rounds } = this.props;

        let netRevenues = 0;
        let netProfits = 0;
        let costOfSales = 0;
        let rndCosts = 0;
        let promotionCosts = 0;
        let sellingCosts = 0;
        let holdingCosts = 0;
        let interestExpense = 0;

        const current_year = this.current_year;
        for (let key in incomeStatement) {
          // eslint-disable-next-line
          res.body.forEach(item => {
            let round_id = item.round;
            let round = rounds.find(i => i.id === round_id);
            let round_number = round.number;
            const hash = incomeStatement[key].name;

            if (round_number === current_year && item[hash]) {
              incomeStatement[key].data.value = item[hash];

              if (hash === "Net Revenues") {
                netRevenues = item[hash];
              } else if (hash === "Net Income") {
                netProfits = item[hash];
              } else if (hash === "Cost of Sales") {
                costOfSales = item[hash];
              } else if (hash === "R&D Costs") {
                rndCosts = item[hash];
              } else if (hash === "Promotion Costs") {
                promotionCosts = item[hash];
              } else if (hash === "Selling Costs") {
                sellingCosts = item[hash];
              } else if (hash === "Holding Costs") {
                holdingCosts = item[hash];
              } else if (hash === "Interest Expense") {
                interestExpense = item[hash];
              }
            }
          });
        }

        this.setState({
          netRevenues,
          netProfits,
          costOfSales,
          rndCosts,
          promotionCosts,
          sellingCosts,
          holdingCosts,
          interestExpense,
          incomeStatement,
          loading3: false
        });
      })
      .catch(err => { });
  };

  loadBalanceSheetData = () => {
    let balanceSheet = { ...this.state.balanceSheet };

    for (let key in balanceSheet) {
      balanceSheet[key].data = {
        value: 0
      };
    }

    this.getBalanceSheet()
      .then(res => {
        const current_year = this.current_year;
        for (let key in balanceSheet) {
          res.body.forEach(item => {
            let round_id = item.round;
            let round = this.props.rounds.find(i => i.id === round_id);
            let round_number = round.number;

            if (round_number === current_year) {
              const hash = balanceSheet[key].name;
              if (item[hash]) {
                balanceSheet[key].data.value = item[hash];
              }
            }
          });
        }

        this.setState({
          balanceSheet,
          loading9: false
        });
      })
      .catch(err => { });
  };

  goToSection = section => {
    this.changeStep(section, 1);
  };

  changeStep = (section, step) => {
    this.setState(
      {
        section,
        step
      },
      () => {
        this.eventemitter.trigger("team-reports-change-section", [
          this.state.section
        ]);
      }
    );
  };

  getActualYearParam(year, key) {
    if (year in this.state.actual) {
      let obj = this.state.actual[year];
      if (key in obj) {
        return obj[key];
      }
    }

    return 0;
  }

  getExpectedYearParam(year, key) {
    if (year in this.state.expected) {
      let obj = this.state.expected[year];
      if (key in obj) {
        return obj[key];
      }
    }

    return 0;
  }

  get expectedNetProfits() {
    return this.getExpectedYearParam(this.current_year, "net_income");
  }

  get actualNetProfits() {
    return this.getActualYearParam(this.current_year, "net_income");
  }

  get current_year() {
    const { currentRound, roundInUrl } = this.state;

    let current_year = currentRound;
    if (roundInUrl !== null && roundInUrl !== currentRound) {
      current_year = roundInUrl;
    }

    return current_year;
  }

  getTotalDemand() {
    const round_number = this.current_year;

    return `${process.env.REACT_APP_API_URL}static/total_demand/?round_number=${round_number}`;
  }

  loadTotalDemand = () => {
    const round_number = this.current_year;

    getRequest(this.getTotalDemand())
      .then(res => {
        let total_demand = {
          auto: 0,
          mobile: 0,
          total: 0
        };
        const obj = res.body.find(i => i.round_number === round_number);

        if (obj) {
          total_demand.auto = obj.auto;
          total_demand.mobile = obj.mobile;
          total_demand.total = obj.total;
        }

        this.setState({
          total_demand,
          loading4: false
        });
      })
      .catch(err => { });
  };

  getManufactureCosts() {
    const round_number = this.current_year;

    return `${process.env.REACT_APP_API_URL}team/manufacture_costs/?round_number=${round_number}`;
  }

  loadManufactureCosts = () => {
    getRequest(this.getManufactureCosts())
      .then(res => {
        let totalCosts = 0;
        let avgMaterialCostsPerUnit = 0;
        let avgLaborCostsPerUnit = 0;
        let avgOverheadCostsPerUnit = 0;

        res.body.forEach(product => {
          totalCosts += product.total_costs;
          avgMaterialCostsPerUnit += product.material_costs;
          avgLaborCostsPerUnit += product.labor_costs;
          avgOverheadCostsPerUnit += product.overhead_costs;
        });

        this.setState({
          totalCosts,
          avgMaterialCostsPerUnit,
          avgLaborCostsPerUnit,
          avgOverheadCostsPerUnit,
          loading5: false
        });
      })
      .catch(err => { });
  };

  getInventoryBalances() {
    const round_number = this.current_year;

    return `${process.env.REACT_APP_API_URL}team/inventory_balances/?round_number=${round_number}`;
  }

  loadInventoryBalances = () => {
    getRequest(this.getInventoryBalances())
      .then(res => {
        let endingInventory = 0;

        res.body.forEach(product => {
          endingInventory += product.ending_inventory;
        });

        this.setState({
          endingInventory,
          loading6: false
        });
      })
      .catch(err => { });
  };

  getMetricsData() {
    const round_number = this.current_year;

    return `${process.env.REACT_APP_API_URL}team/report/metrics/?round_number=${round_number}`;
  }

  loadMetricsData = () => {
    getRequest(this.getMetricsData())
      .then(res => {
        let metrics = {
          debt: "0.00",
          equity: "100.00",
          wacc: "0.00"
        };

        if (res.body[0]["Debt to Total Capital"]) {
          metrics.debt = (res.body[0]["Debt to Total Capital"] * 100).toFixed(
            2
          );
          metrics.equity = (100 - Number(metrics.debt)).toFixed(2);
        }

        if (res.body[0]["WACC"]) {
          metrics.wacc = (res.body[0]["WACC"] * 100).toFixed(2);
        }

        this.setState({
          metrics,
          loading7: false
        });
      })
      .catch(err => { });
  };

  getCashFlow() {
    const round_number = this.current_year;

    return `${process.env.REACT_APP_API_URL}team/report/cashflow/?round_number=${round_number}`;
  }

  loadCashFlow = () => {
    // cashFlow
    let cashFlow = { ...this.state.cashFlow };

    for (let key in cashFlow) {
      cashFlow[key].data = {
        value: 0
      };
    }

    getRequest(this.getCashFlow())
      .then(res => {
        let debtBorrowed = 0;
        let stockIssuance = 0;
        let debtRepaid = 0;
        let dividends = 0;
        let stockRepurchase = 0;

        const current_year = this.current_year;
        for (let key in cashFlow) {
          // eslint-disable-next-line
          res.body.forEach(item => {
            let round_id = item.round;
            let round = this.props.rounds.find(i => i.id === round_id);
            let round_number = round.number;
            const hash = cashFlow[key].name;

            if (round_number === current_year && item[hash]) {
              cashFlow[key].data.value = item[hash];

              if (hash === "Stock Repurchase") {
                stockRepurchase = item[hash];
              } else if (hash === "Dividends") {
                dividends = item[hash];
              } else if (hash === "Debt Repaid") {
                debtRepaid = item[hash];
              } else if (hash === "Stock Issuance") {
                stockIssuance = item[hash];
              } else if (hash === "Debt Borrowed") {
                debtBorrowed = item[hash];
              }
            }
          });
        }

        const financeRaised = debtBorrowed + stockIssuance;
        const returnedToInvestors = debtRepaid + dividends + stockRepurchase;

        this.setState({
          financeRaised,
          returnedToInvestors,
          cashFlow,
          loading8: false
        });
      })
      .catch(err => { });
  };

  get isLoading() {
    const {
      loading1,
      loading2,
      loading3,
      loading4,
      loading5,
      loading6,
      loading7,
      loading8,
      loading9,
      loading10,
      loading11
    } = this.state;

    return (
      loading1 ||
      loading2 ||
      loading3 ||
      loading4 ||
      loading5 ||
      loading6 ||
      loading7 ||
      loading8 ||
      loading9 ||
      loading10 ||
      loading11
    );
  }

  loadSharePrice = () => {
    getRequest(`${process.env.REACT_APP_API_URL}static/constants/`)
      .then(res => {
        const { initial_share_price } = res.body[0];

        this.setState({
          share_price: initial_share_price,
          loading10: false
        });
      })
      .catch(err => { });
  };

  loadCompetitionMetrics = () => {
    getRequest(this.getCompetitionMetrics())
      .then(res => {
        let competition_metrics = {};

        res.body.forEach(row => {
          competition_metrics[row.team] = {
            MarketShare: row["Market Share"] ? row["Market Share"] : 0,
            Revenues: row["Net Revenues"] ? row["Net Revenues"] : 0,
            GrossMargins: row["Gross Margin"] ? row["Gross Margin"] : 0
          };
        });

        this.setState({
          competition_metrics,
          loading11: false
        });
      })
      .catch(err => { });
  };

  render() {
    const {
      section,
      step,
      data,
      teams,
      netRevenues,
      netProfits,
      actual,
      expected,
      incomeStatement,
      balanceSheet,
      cashFlow,
      costOfSales,
      rndCosts,
      promotionCosts,
      sellingCosts,
      total_demand,
      holdingCosts,
      endingInventory,
      totalCosts,
      avgMaterialCostsPerUnit,
      avgLaborCostsPerUnit,
      avgOverheadCostsPerUnit,
      interestExpense,
      financeRaised,
      returnedToInvestors,
      metrics,
      competition_metrics,
      share_price
    } = this.state;
    const { rank_name, team_grade } = this.props;
    const current_year = this.current_year;
    const isLoading = this.isLoading;

    return (
      <div className="team-reports-container">
        <TeamReportsTopNavigation
          section={section}
          step={step}
          changeStep={this.changeStep}
          current_year={current_year}
        />
        {section === 1 && isLoading === false && (
          <TeamReportsSection1 step={step} rank_name={rank_name} />
        )}
        {section === 2 && isLoading === false && (
          <TeamReportsSection2
            step={step}
            team_grade={team_grade}
            rank_name={rank_name}
            data={data}
            teams={teams}
            share_price={share_price}
            current_year={current_year}
            competition_metrics={competition_metrics}
          />
        )}
        {section === 3 && isLoading === false && (
          <TeamReportsSection3
            step={step}
            expectedNetProfits={this.expectedNetProfits}
            actualNetProfits={this.actualNetProfits}
            netRevenues={netRevenues}
            netProfits={netProfits}
            actual={actual}
            expected={expected}
            current_year={current_year}
            incomeStatement={incomeStatement}
          />
        )}
        {section === 4 && isLoading === false && (
          <TeamReportsSection4
            step={step}
            incomeStatement={incomeStatement}
            costOfSales={costOfSales}
            netRevenues={netRevenues}
            rndCosts={rndCosts}
            promotionCosts={promotionCosts}
            sellingCosts={sellingCosts}
            current_year={current_year}
            data={data}
            teams={teams}
            total_demand={total_demand}
            endingInventory={endingInventory}
          />
        )}
        {section === 5 && isLoading === false && (
          <TeamReportsSection5
            step={step}
            data={data}
            teams={teams}
            costOfSales={costOfSales}
            holdingCosts={holdingCosts}
            incomeStatement={incomeStatement}
            current_year={current_year}
            totalCosts={totalCosts}
            avgMaterialCostsPerUnit={avgMaterialCostsPerUnit}
            avgLaborCostsPerUnit={avgLaborCostsPerUnit}
            avgOverheadCostsPerUnit={avgOverheadCostsPerUnit}
          />
        )}
        {section === 6 && isLoading === false && (
          <TeamReportsSection6
            step={step}
            incomeStatement={incomeStatement}
            current_year={current_year}
            interestExpense={interestExpense}
            data={data}
            teams={teams}
            metrics={metrics}
            financeRaised={financeRaised}
            returnedToInvestors={returnedToInvestors}
          />
        )}
        {section === 7 && isLoading === false && (
          <TeamReportsSection7
            step={step}
            incomeStatement={incomeStatement}
            balanceSheet={balanceSheet}
            cashFlow={cashFlow}
            current_year={current_year}
          />
        )}
        {isLoading === true && (
          <div className="team-reports-loading">
            <Loader type="ball-scale-ripple" active />
          </div>
        )}
      </div>
    );
  }
}

export default TeamReports;



// WEBPACK FOOTER //
// ./src/containers/team-reports.js